const LOCAL_API = 'http://localhost:4200/';
// const DEV_API = 'https://16d4-122-179-66-233.ngrok-free.app/qbr/';
//const DEV_API = 'https://c11592adf98d.ngrok-free.app/qbr/';
// const DEV_API = `https://8b9f1030a8e3.ngrok-free.app/qbr/`;
// const DEV_API = `http://34.42.101.219:8080/qbr/`
const DEV_API = 'https://quickbusride.in/qbr/';
//const DEV_API = 'http://localhost:8080/qbr/';

const BASE_UTL: string = process.env.REACT_APP_USE_STATIC_JSON === 'true' ?LOCAL_API: DEV_API;
//console.log('process.env.REACT_APP_USE_STATIC_JSON', process.env.REACT_APP_USE_STATIC_JSON)
export const API_CONSTANTS = {
    BUS_LOCATIONS: `${BASE_UTL}busStops`,
    BUS_REGISTRATIONS: `${BASE_UTL}busRegistrations`,
    BUS_SEARCH: `${BASE_UTL}getBus`,
    BUS_LAYOUT: `${BASE_UTL}getBusSeatLayout`,
    BOOKING_DETAILS: `${BASE_UTL}bookSeat`,
    GENERATE_OTP_AND_BOOK: `${BASE_UTL}generateOtpAndBookTicket`,
    VALIDATE_OTP_AND_BOOK: `${BASE_UTL}validateOtpAndBlockSeats`,
    BOOKING_HISTORY: `${BASE_UTL}getBookedTickets`,
    CANCEL_TICKET: `${BASE_UTL}cancelTickets`,
    GENERATE_OTP: `${BASE_UTL}generateOtp`,
    VERIFY_OTP_AND_GET_TICKET_LIST: `${BASE_UTL}validateOtpAndGetTicketList`,
    CREATE_ORDER: `${BASE_UTL}createBookingOrder`,
    VERIFY_PAYMENT: `${BASE_UTL}verifyPayment`,
    CONFIRM_BOOKING: `${BASE_UTL}confirmBooking`,
    REFUND_UNCONFIRMED_PAYMENT: `${BASE_UTL}refundUnconfirmedPayment`,
    INTERNAL_REQUEST_OTP: `${BASE_UTL}internal/requestOtp`,
    INTERNAL_VERIFY_OTP: `${BASE_UTL}internal/verifyOtp`,
    INTERNAL_SEAT_LAYOUT: `${BASE_UTL}internal/seatLayout`,
    INTERNAL_BOOK_SEATS: `${BASE_UTL}internal/bookSeats`,
    INTERNAL_BLOCK_SEATS: `${BASE_UTL}internal/blockSeats`,
    INTERNAL_UNBLOCK_SEATS: `${BASE_UTL}internal/unblockSeats`,
    INTERNAL_BOOKED_TICKETS: `${BASE_UTL}internal/bookedTickets`,
    INTERNAL_DAY_STATUS: `${BASE_UTL}internal/dayStatus`,
    INTERNAL_CANCEL_BUS: `${BASE_UTL}internal/cancelBus`,
    INTERNAL_CONTINUE_BUS: `${BASE_UTL}internal/continueBus`,
    INTERNAL_STOP_ONLINE: `${BASE_UTL}internal/stopOnlineBooking`,
    INTERNAL_START_ONLINE: `${BASE_UTL}internal/startOnlineBooking`,
    INTERNAL_DELETE_SCHEDULE: `${BASE_UTL}internal/deleteSchedule`,
    INTERNAL_RESCHEDULE_BUS: `${BASE_UTL}internal/rescheduleBus`,
    INTERNAL_REDBUS_SEATS: `${BASE_UTL}internal/redbusSeats`,
    INTERNAL_SAVE_REDBUS_SEATS: `${BASE_UTL}internal/saveRedbusSeats`,
}